export default "__VITE_ASSET__B3c9N0bp__"